var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Button from '@doordash/component-button';
import LayerManager from '@doordash/component-layer-manager';
import { Modal } from '@doordash/component-modal';
import { InlineChildren, Themes, Theming } from '@doordash/design-language';
import path from 'path-parse';
import * as React from 'react';
import { CropperContainer } from './CropperContainer';
import { FileUploadView } from './FileUploadView';
import ImagePreview from './ImagePreview';
import Strings from './Strings';
import { FooterButtonWrapper, ViewGuidelinesButtonWrapper } from './styles';
import { calculateMinZoom, getImageDimensions, imgBlobToBase64, imgUrlToBase64, isImageDimensionValid, isImageTypeValid, } from './utils';
var MODAL_CONTENT_HEIGHT = 460;
var MODAL_CONTENT_WIDTH = 400;
var MODAL_WIDTH = 480;
var MODAL_HEIGHT = 660;
var ModalStates = {
    uploadState: 'uploadState',
    cropState: 'cropState',
    previewState: 'previewState',
    enhanceState: 'enhanceState',
};
export var ImageCropModal = function (_a) {
    var aspect = _a.aspect, _b = _a.isCircleCrop, isCircleCrop = _b === void 0 ? false : _b, imgSrc = _a.imgSrc, photoGuidelinesUrl = _a.photoGuidelinesUrl, uploadCallBack = _a.uploadCallBack, onClose = _a.onClose, uploadImageMinWidth = _a.uploadImageMinWidth, uploadImageMinHeight = _a.uploadImageMinHeight, zoomStep = _a.zoomStep, isSaving = _a.isSaving, enhancePhoto = _a.enhancePhoto, originalFilename = _a.originalFilename;
    var minZoom = 1;
    var _c = React.useState(ModalStates.uploadState), modalState = _c[0], setModalState = _c[1];
    var _d = React.useState(''), imageBase64 = _d[0], setImageBase64 = _d[1];
    var _e = React.useState({
        x: 0,
        y: 0,
        width: 0,
        height: 0,
    }), croppedArea = _e[0], setCroppedAreaPixels = _e[1];
    var _f = React.useState(''), errorMessage = _f[0], setErrorMessage = _f[1];
    var _g = React.useState(null), photoResult = _g[0], setPhotoResult = _g[1];
    var _h = React.useState(2), maxZoom = _h[0], setMaxZoom = _h[1];
    var _j = React.useState(minZoom), initialZoom = _j[0], setInitialZoom = _j[1];
    var _k = React.useState(MODAL_CONTENT_HEIGHT), cropperHeight = _k[0], setCropperHeight = _k[1];
    var _l = React.useState(MODAL_CONTENT_WIDTH), cropperWidth = _l[0], setCropperWidth = _l[1];
    var _m = React.useState(originalFilename), fileName = _m[0], setFilename = _m[1];
    var _o = React.useState(false), enhancingPhoto = _o[0], setEnhancingPhoto = _o[1];
    var handleBase64Loaded = function (base64ImgSrc) {
        setImageBase64(base64ImgSrc);
        setModalState(ModalStates.cropState);
    };
    var handleImgSrcProvided = function () { return __awaiter(void 0, void 0, void 0, function () {
        var img_1;
        return __generator(this, function (_a) {
            if (imgSrc) {
                img_1 = new Image();
                // when imgSrc is image URL
                if (typeof imgSrc === 'string') {
                    img_1.src = imgSrc;
                    imgUrlToBase64(imgSrc, handleBase64Loaded);
                    if (!originalFilename) {
                        setFilename(path(imgSrc).base);
                    }
                }
                // when imgSrc is a file
                else {
                    setFilename(imgSrc.name);
                    img_1.src = URL.createObjectURL(imgSrc);
                    imgBlobToBase64(imgSrc, handleBase64Loaded);
                }
                img_1.onload = function () { return __awaiter(void 0, void 0, void 0, function () {
                    var height, width, minZoomCalculated;
                    return __generator(this, function (_a) {
                        height = img_1.height;
                        width = img_1.width;
                        minZoomCalculated = calculateMinZoom(width, height, MODAL_CONTENT_HEIGHT, MODAL_CONTENT_WIDTH, cropperHeight, cropperWidth);
                        setInitialZoom(minZoomCalculated);
                        setMaxZoom(minZoomCalculated + (minZoomCalculated - minZoom));
                        return [2 /*return*/];
                    });
                }); };
            }
            return [2 /*return*/];
        });
    }); };
    // calculate cropper dimension based on aspect ratio
    var calculateCropperDimension = function () {
        if (isCircleCrop) {
            setCropperHeight(cropperWidth);
            return;
        }
        aspect > 1
            ? setCropperHeight(MODAL_CONTENT_WIDTH / aspect)
            : setCropperWidth(MODAL_CONTENT_HEIGHT * aspect);
    };
    var showEnhancedProcessing = enhancePhoto && enhancingPhoto;
    React.useEffect(function () {
        handleImgSrcProvided();
        calculateCropperDimension();
    }, []);
    var handleFileDrop = function (acceptedFiles) { return __awaiter(void 0, void 0, void 0, function () {
        var imageFile, isTypeValid, isDimensionValid, imageInfo, imgWidth, imgHeight, minZoomCalculated;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!acceptedFiles.length) return [3 /*break*/, 3];
                    imageFile = acceptedFiles[0];
                    isTypeValid = isImageTypeValid(imageFile);
                    setFilename(acceptedFiles[0].path);
                    if (!isTypeValid) {
                        setErrorMessage(Strings.Errors.fileTypeError);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, isImageDimensionValid(imageFile, uploadImageMinWidth, uploadImageMinHeight)];
                case 1:
                    isDimensionValid = _a.sent();
                    if (!isDimensionValid) {
                        setErrorMessage(Strings.Errors.fileDimensionError(uploadImageMinWidth, uploadImageMinHeight));
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, getImageDimensions(imageFile)];
                case 2:
                    imageInfo = (_a.sent());
                    imgWidth = imageInfo.width;
                    imgHeight = imageInfo.height;
                    minZoomCalculated = calculateMinZoom(imgWidth, imgHeight, MODAL_CONTENT_HEIGHT, MODAL_CONTENT_WIDTH, cropperHeight, cropperWidth);
                    setInitialZoom(minZoomCalculated);
                    setMaxZoom(minZoomCalculated + (minZoomCalculated - minZoom));
                    imgBlobToBase64(imageFile, setImageBase64);
                    setModalState(ModalStates.cropState);
                    setErrorMessage('');
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleNext = function () {
        setModalState(ModalStates.previewState);
    };
    var handleBack = function () {
        setModalState(ModalStates.cropState);
    };
    var displayTitle = function () {
        if (modalState === ModalStates.uploadState) {
            return Strings.ModalTitle.uploadImage;
        }
        if (modalState === ModalStates.cropState) {
            return Strings.ModalTitle.adjustImage;
        }
        return Strings.ModalTitle.previewImage;
    };
    // Returns the cropped photo and enhances the photo if the cropped photo
    // is smaller than the minimum resolution
    var getCroppedPhoto = function (photo) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve) {
                    if (enhancePhoto) {
                        var img_2 = new Image();
                        img_2.src = URL.createObjectURL(photo);
                        img_2.onload = function () { return __awaiter(void 0, void 0, void 0, function () {
                            var height, width, photoUrl, photoData, photoBlob, fileNameWithExt, photoFile, e_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        height = img_2.height;
                                        width = img_2.width;
                                        if (!(height < uploadImageMinHeight || width < uploadImageMinWidth)) return [3 /*break*/, 7];
                                        setEnhancingPhoto(true);
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([1, 5, , 6]);
                                        return [4 /*yield*/, enhancePhoto(photoResult)];
                                    case 2:
                                        photoUrl = _a.sent();
                                        return [4 /*yield*/, fetch(photoUrl)];
                                    case 3:
                                        photoData = _a.sent();
                                        return [4 /*yield*/, photoData.blob()];
                                    case 4:
                                        photoBlob = _a.sent();
                                        fileNameWithExt = fileName;
                                        if (!path(fileName).ext) {
                                            fileNameWithExt = "".concat(fileName, ".jpg");
                                        }
                                        photoFile = new File([photoBlob], fileNameWithExt, {
                                            type: 'image/jpeg',
                                        });
                                        setEnhancingPhoto(false);
                                        return [2 /*return*/, resolve(photoFile)];
                                    case 5:
                                        e_1 = _a.sent();
                                        // TODO: Surface error message
                                        setEnhancingPhoto(false);
                                        return [3 /*break*/, 6];
                                    case 6: return [3 /*break*/, 8];
                                    case 7: return [2 /*return*/, resolve(photo)];
                                    case 8: return [2 /*return*/];
                                }
                            });
                        }); };
                    }
                    else {
                        return resolve(photo);
                    }
                })];
        });
    }); };
    var onSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var croppedPhoto;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getCroppedPhoto(photoResult)];
                case 1:
                    croppedPhoto = (_a.sent());
                    return [4 /*yield*/, uploadCallBack(croppedPhoto)];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(Theming, { overrides: Themes.Merchant },
        React.createElement(LayerManager, null,
            React.createElement(Modal, { size: Modal.Sizes.Custom, customSize: {
                    maxHeight: MODAL_HEIGHT,
                    maxWidth: MODAL_WIDTH,
                }, onClose: onClose, title: displayTitle(), hasContentPadding: false, hasHeaderPadding: true, renderFooterContent: function () {
                    return imageBase64 && (React.createElement(FooterButtonWrapper, { justifyContent: InlineChildren.Justification.SpaceBetween },
                        photoGuidelinesUrl && photoGuidelinesUrl.length > 0 ? (React.createElement(ViewGuidelinesButtonWrapper, { href: photoGuidelinesUrl, target: "_blank" },
                            React.createElement(Button, { type: Button.Types.Tertiary, isInline: true }, Strings.ModalFooter.viewImageGuidelines))) : (React.createElement("div", null)),
                        React.createElement(InlineChildren, { justifyContent: InlineChildren.Justification.FlexEnd },
                            modalState === ModalStates.cropState ? (React.createElement(Button, { type: Button.Types.Tertiary, onClick: onClose, isInline: true }, Strings.ModalFooter.cancel)) : (React.createElement(Button, { type: Button.Types.Tertiary, onClick: handleBack, isInline: true }, Strings.ModalFooter.back)),
                            modalState === ModalStates.cropState ? (React.createElement(Button, { onClick: handleNext, isInline: true }, Strings.ModalFooter.next)) : (React.createElement(Button, { onClick: onSave, isInline: true, state: isSaving || enhancingPhoto
                                    ? Button.States.Loading
                                    : Button.States.Default }, Strings.ModalFooter.save)))));
                } },
                modalState === ModalStates.uploadState && (React.createElement(FileUploadView, { photoGuidelinesUrl: photoGuidelinesUrl, onFileDrop: handleFileDrop, uploadImageMinWidth: uploadImageMinWidth, uploadImageMinHeight: uploadImageMinHeight, errorMessage: errorMessage })),
                modalState === ModalStates.cropState && (React.createElement(CropperContainer, { imgSrc: imageBase64, setCroppedAreaPixels: setCroppedAreaPixels, isCircleCrop: isCircleCrop, aspect: aspect, min: minZoom, max: maxZoom, initialZoom: initialZoom, step: zoomStep, cropperHeight: cropperHeight, cropperWidth: cropperWidth })),
                modalState === ModalStates.previewState && croppedArea && (React.createElement(ImagePreview, { fileName: fileName, aspect: aspect, isCircleCrop: isCircleCrop, imgSrc: imageBase64, croppedArea: croppedArea, setPhotoResult: setPhotoResult, isLoading: showEnhancedProcessing }))))));
};
